import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import useClinicalRecordService from '../../clinicalRecordService';
import useIntakeData from '../../intakeDataService';
import useAdministrationService from './administration';
import useNewEpisodeofCareService from './createNewEpisode';

export default function useEpisodeofCareService() {
  const queryClient = useQueryClient();
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const administration = useAdministrationService();
  const intakeOptions = useIntakeData();
  const clinicalRecord = useClinicalRecordService(patientUuid);
  const newEpisodeofCare = useNewEpisodeofCareService();

  const invalidatePatientQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['camel', 'patients', patientUuid],
    });
  };

  return {
    reset: () => {
      administration.refetch();
      clinicalRecord.refetch();
    },
    ...administration,
    ...newEpisodeofCare,
    invalidatePatientQuery,
    // TODO: Remove this commit when confirm this not used.
    // isFieldDisabled: updatingStatus === updatingStatusEnum.inProgress ?? false,
    isFieldDisabled: false,
    isLoading:
      administration.isLoading || intakeOptions.isLoading || clinicalRecord?.state?.isLoading,
    isError: administration.isError || intakeOptions.isError || clinicalRecord?.state?.isError,
  };
}
